import { ISwAppTeamsAndSecurityApi } from "../../interfaces-and-types";

type TTeamAndSecurityUrls = {
  [key in keyof ISwAppTeamsAndSecurityApi]: string;
};

const rootTeamAndSecurityUrl = "/settings/team-and-security";

const rootClaimsAndPermissionsUrl = "/settings/claims-and-permissions";

export const teamAndSecurityUrls: TTeamAndSecurityUrls = {
  // invitation acceptance
  acceptTeamInvitation: `invitations/accept-team-invitation`, // must not be embedded inside the settings page, else auth issues

  // claims and permissions
  getCustomClaims: `${rootClaimsAndPermissionsUrl}`,
  getCustomClaimById: `${rootClaimsAndPermissionsUrl}`,
  createCustomClaim: `${rootClaimsAndPermissionsUrl}`,
  editCustomClaim: `${rootClaimsAndPermissionsUrl}/id`,
  deleteCustomClaims: `${rootClaimsAndPermissionsUrl}/id`,
  getAvailableAccessClaims: `${rootClaimsAndPermissionsUrl}/available-access-claims`,
  getAvailablePermissions: `${rootClaimsAndPermissionsUrl}/available-permissions`,
  getPermissionsForClaim: `${rootClaimsAndPermissionsUrl}/permissions-for-claim`,

  // team and security
  getTeamMembers: `${rootTeamAndSecurityUrl}`,
  getTeamMemberById: `${rootTeamAndSecurityUrl}/id`,
  // editTeamMember: `${rootTeamAndSecurityUrl}/id`,
  deleteTeamMember: `${rootTeamAndSecurityUrl}/id`,
  inviteTeamMember: `${rootTeamAndSecurityUrl}/invite-team-member`,
  registerWithInvitationCode: `${rootTeamAndSecurityUrl}/register-with-code`,
  resendInvitationLink: `${rootTeamAndSecurityUrl}/resend-invitation-link/id`,
  deleteTeamMemberInvitation: `${rootTeamAndSecurityUrl}/team-invitations/id`,
  // addTeamMemberAccessClaim: `${rootTeamAndSecurityUrl}/user/$team_member_id/claims/$claim`,
  addTeamMemberAccessClaim: `${rootTeamAndSecurityUrl}/user/$team_member_id/claims`,
  deleteTeamMemberAccessClaim: `${rootTeamAndSecurityUrl}/user/$team_member_id/claims/$claim`,
  toggleTeamMemberStatus: `${rootTeamAndSecurityUrl}/user/id/toggle-member-status`,

  // security: user tranfer limits
  getUserTransferLimitById: `${rootTeamAndSecurityUrl}/user/transfer-limits/$id`,
  getUserTransferLimitByCurrency: `${rootTeamAndSecurityUrl}/user/$team_member_id/transfer-limits/$currency`,
  setTeamMemberTransferLimits: `${rootTeamAndSecurityUrl}/user/$team_member_id/transfer-limits`,
  clearTeamMemberTransferLimits: `${rootTeamAndSecurityUrl}/user/$team_member_id/transfer-limits/$currency`,
};
